import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

export type InvoicePaymentRequestRow = {
  id: string;
  invoice_id: string;
  channel: string;
  provider: string;
  requested_method: string | null;
  status: string;
  pay_token: string | null;
  amount_cents: number;
  currency: string;
  sent_at: string | null;
  expires_at: string | null;
  created_at: string;
};

export function paymentRequestsQueryKey(invoiceId: string | null | undefined) {
  return ['payment-requests', invoiceId ?? null] as const;
}

export function useInvoicePaymentRequests(invoiceId: string | null | undefined) {
  return useQuery({
    queryKey: paymentRequestsQueryKey(invoiceId),
    enabled: Boolean(invoiceId),
    queryFn: async (): Promise<InvoicePaymentRequestRow[]> => {
      const { data, error } = await supabase
        .from('payment_requests' as never)
        .select(
          'id, invoice_id, channel, provider, requested_method, status, pay_token, amount_cents, currency, sent_at, expires_at, created_at',
        )
        .eq('invoice_id', invoiceId as string)
        .order('created_at', { ascending: false });
      if (error) throw error;
      return (data ?? []) as InvoicePaymentRequestRow[];
    },
  });
}
